<template>
	<div id="wrapper">
		<SidebarView :members="true" :add-member="true" :member-visible="true" />
		<div>
			<div>
				<TopbarView />
				<form @submit.prevent="submitMember()" :add_or_edit="add_or_edit">
					<div class="mx-3">
						<div class="row">
							<div class="col-md-12">
								<!-- <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size mb-2">
                  Save
                </button> -->
								<SaveButton :isSaving="isSaving" />
							</div>
							<div class="general-error d-flex justify-content-center pt-2 pb-2">
								<errors v-if="form.message">
									{{ form.message }}
								</errors>
							</div>
							<div>
								<b-card>
									<!-- Replace your existing b-tabs content -->
									<b-tabs content-class="mt-3" v-model="activeTab">
										<!-- Individual Tab (your existing content) -->
										<b-tab title="INDIVIDUAL" @click="
											setCustomerType('INDIVIDUAL')
											" active>
											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header d-flex flex-row justify-content-between align-items-center">
														<h6 class="m-0 fw-bold text-green">
															Personal Details
														</h6>

														<div class="d-flex gap-2">
															<a title="Print Form" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="showPrintableFormModal('individual_filled')">
																<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'print']" /></span>
															</a>
															<a title="Get Empty Form" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="showPrintableFormModal('individual')">
																<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'book']" /></span>
															</a>
														</div>
													</div>
													<div class="card-body">
														<personal-details :form="form" :add_or_edit="add_or_edit
															" :users_option="users_option
																"></personal-details>
														<div class="row mt-2">
															<div class="col-12 col-md-3">
																<div class="form-group">
																	<label class="akkurate-dark d-flex justify-content-between small mb-2" for="profile_picture">
																		<div>
																			Passport
																			Picture
																			<star></star>
																		</div>
																		<a class="btn btn-sm akkurate-danger-btn" @click="
																			removeFile(
																				'profile'
																			)
																			"><span class="akkurate-small text-white">
																				<font-awesome-icon :icon="[
																					'fas',
																					'trash',
																				]" /></span></a>
																	</label>
																	<b-form-group id="choose_file" label-for="choose_file">
																		<vue-dropzone ref="profileDropzone" @vdropzone-files-added="
																			onProfilePictureUpload
																		" id="dropzone" :options="dropzoneOptions
																			"></vue-dropzone>
																	</b-form-group>
																	<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																	<errors v-if="
																		form
																			.errors
																			.profile_picture
																	">
																		{{
																			form
																				.errors
																				.profile_picture[0]
																		}}
																	</errors>
																</div>
															</div>
															<div class="col-12 col-md-3">
																<div class="form-group">
																	<label class="akkurate-dark d-flex justify-content-between small mb-2" for="ghana_card_front">
																		<div>
																			Ghana
																			Card
																			(Front)
																			<star></star>
																		</div>
																		<a class="btn btn-sm akkurate-danger-btn" @click="
																			removeFile(
																				'ghanaCardFront'
																			)
																			"><span class="akkurate-small text-white">
																				<font-awesome-icon :icon="[
																					'fas',
																					'trash',
																				]" /></span></a>
																	</label>
																	<b-form-group id="choose_file" label-for="choose_file">
																		<vue-dropzone ref="ghanaCardFrontDropzone" @vdropzone-files-added="
																			onGhanaCardFrontUpload
																		" id="dropzone" :options="dropzoneOptions
																			"></vue-dropzone>
																	</b-form-group>
																	<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																	<errors v-if="
																		form
																			.errors
																			.gh_card_front_path
																	">
																		{{
																			form
																				.errors
																				.gh_card_front_path[0]
																		}}
																	</errors>
																</div>
															</div>
															<div class="col-12 col-md-3">
																<div class="form-group">
																	<label class="akkurate-dark d-flex justify-content-between small mb-2" for="ghana_card_back">
																		<div>
																			Ghana
																			Card
																			(Back)
																			<star></star>
																		</div>
																		<a class="btn btn-sm akkurate-danger-btn" @click="
																			removeFile(
																				'ghanaCardBack'
																			)
																			"><span class="akkurate-small text-white">
																				<font-awesome-icon :icon="[
																					'fas',
																					'trash',
																				]" /></span></a>
																	</label>
																	<b-form-group id="choose_file" label-for="choose_file">
																		<vue-dropzone ref="ghanaCardBackDropzone" @vdropzone-files-added="
																			onGhanaCardBackUpload
																		" id="dropzone" :options="dropzoneOptions
																			"></vue-dropzone>
																	</b-form-group>
																	<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																	<errors v-if="
																		form
																			.errors
																			.gh_card_back_path
																	">
																		{{
																			form
																				.errors
																				.gh_card_back_path[0]
																		}}
																	</errors>
																</div>
															</div>
															<div class="col-12 col-md-3">
																<div class="form-group">
																	<label class="akkurate-dark d-flex justify-content-between small mb-2" for="signature">
																		<div>
																			Signature
																			(Max.
																			2.5MB)<star></star>
																		</div>
																		<a class="btn btn-sm akkurate-danger-btn" @click="
																			removeFile(
																				'signature'
																			)
																			"><span class="akkurate-small text-white">
																				<font-awesome-icon :icon="[
																					'fas',
																					'trash',
																				]" /></span></a>
																	</label>
																	<b-form-group id="choose_file" label-for="choose_file">
																		<vue-dropzone ref="signatureDropzone" @vdropzone-files-added="
																			onSignatureUpload
																		" id="dropzone" :options="dropzoneOptions
																			"></vue-dropzone>
																	</b-form-group>
																	<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																	<errors v-if="
																		form
																			.errors
																			.signature
																	">
																		{{
																			form
																				.errors
																				.signature[0]
																		}}
																	</errors>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header d-flex flex-row align-items-center">
														<h6 class="m-0 fw-bold text-green">
															Employment Details
														</h6>
													</div>
													<div class="card-body">
														<employer-details :form="form" :add_or_edit="add_or_edit
															"></employer-details>
													</div>
												</div>
											</div>

											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header d-flex flex-row align-items-center">
														<h6 class="m-0 fw-bold text-green">
															Financial
															Information
														</h6>
													</div>
													<div class="card-body">
														<financial-information :form="form" :add_or_edit="add_or_edit
															"></financial-information>
													</div>
												</div>
											</div>

											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header d-flex flex-row align-items-center">
														<h6 class="m-0 fw-bold text-green">
															Address
														</h6>
													</div>
													<div class="card-body">
														<address-view :form="form" :region_options="region_options
															" :branch_options="branch_options
																"></address-view>
													</div>
												</div>
											</div>
											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header d-flex flex-row align-items-center">
														<h6 class="m-0 fw-bold text-green">
															Spouse Details
														</h6>
													</div>
													<div class="card-body">
														<spouse-details :form="form" :add_or_edit="add_or_edit
															"></spouse-details>
													</div>
												</div>
											</div>

											<div class="d-flex flex-row align-items-center justify-content-between my-2">
												<AddAccount :add_account="'add-account-one'" :account_types="account_types
													" @addAccount="addAccount">
												</AddAccount>
											</div>
											<div class="err-accounts">
												<errors v-if="form.errors.accounts">
													{{
														form.errors.accounts[0]
													}}
												</errors>
											</div>
											<div class="col-12 col-md-12">
												<div class="card card-shape home-box">
													<div class="card-header">
														<div class="d-flex flex-row align-items-center justify-content-between">
															<h6 class="m-0 fw-bold text-green">
																Accounts
															</h6>
															<b-button size="sm" class="fw-semibold akkurate-green-btn btn-size" @click="
																$bvModal.show(
																	'add-account-one'
																)
																">
																<span class="akkurate-small">
																	<i class="fas fa-plus"></i>
																	Add Acounts
																</span>
															</b-button>
														</div>
													</div>
													<div class="card-body">
														<vue-good-table :columns="columns" :rows="form.accounts
															" />
													</div>
												</div>
											</div>
											<!-- ajks -->
											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header">
														<div class="d-flex flex-row align-items-center justify-content-between">
															<h6 class="m-0 fw-bold text-green">
																Account Priority Type
															</h6>
														</div>
													</div>
													<div class="card-body">
														<!-- <vue-good-table :columns="columns" :rows="form.accounts
															" /> -->

														<div class="row">
															<div class="col-12 col-md-6 mb-2">
																<label class="akkurate-dark small" for="priority">Priority Type<star></star></label>
																<b-form-group id="priority" label-for="priority">
																	<multiselect class="mt-1 field-container" v-model="selectedPriority" :options="priorityTypeOptions" label="name" >
																	</multiselect>
																	<errors v-if="form.errors.customer_category">
																		{{ form.errors.customer_category[0] }}
																	</errors>
																</b-form-group>
															</div>

															<div class="col-12 col-md-6 mb-2">
																<b-form-group label-for="priority_note" class="mb-2">
																	<template #label>
																		<label class="akkurate-dark small" for="priority_note">Note </label>
																	</template>
																	<b-form-input class="mt-1 field-container fields" type="text" placeholder="" v-model="setNote" disabled></b-form-input>
																	<!-- <b-form-textarea class="mt-1 fields" id="priority_note" v-model="setNote" placeholder=""></b-form-textarea> -->
																</b-form-group>

															</div>
														</div>
													</div>
												</div>
											</div>


											<div class="col-12 col-md-12 mt-2">
												<div class="card card-shape home-box">
													<div class="card-header d-flex flex-row align-items-center" style="
															display: flex;
															justify-content: space-between;
														">
														<div class="">
															<h6 class="m-0 fw-bold text-green">
																Reference Details / In-Trust Of
															</h6>
														</div>
														<div class="">
															<span>
																<h6 class="mb-0 akkurate-green small">
																	In case of
																	an emergency
																</h6>
															</span>
														</div>
													</div>
													<div class="card-body">
														<emergency-contact-details :form="form" :add_or_edit="add_or_edit
															"></emergency-contact-details>
													</div>
												</div>
											</div>

											<div class="d-flex flex-row align-items-center justify-content-between my-2">
												<NextOfKin @addNextOfKin="
													addBeneficiary
												" />
											</div>
											<div class="col-12 col-md-12">
												<div class="card card-shape home-box">
													<div class="card-header">
														<div class="d-flex flex-row align-items-center justify-content-between">
															<h6 class="m-0 fw-bold text-green">
																Beneficiary
															</h6>
															<b-button size="sm" class="fw-semibold akkurate-green-btn btn-size" v-b-modal.add-nextofkin><span class="akkurate-small"><i class="fas fa-plus"></i>
																	Add
																	Beneficiary</span></b-button>
														</div>
													</div>
													<div class="card-body">
														<vue-good-table :columns="kin_columns
															" :rows="form.beneficiaries
																" />
													</div>
												</div>
											</div>
										</b-tab>

										<!-- Group Tab -->
										<b-tab title="GROUP" @click="setCustomerType('GROUP')">
											<div class="row">
												<div class="col-12">
													<!-- Group Information -->
													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header justify-content-between d-flex flex-row align-items-center">
																<h6 class="m-0 fw-bold text-green">
																	Group
																	Information
																</h6>

																<div class="d-flex gap-2">
																	<a title="Print Form" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="showPrintableFormModal('group_filled')">
																		<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'print']" /></span>
																	</a>
																	<a title="Get Empty Form" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="showPrintableFormModal('group')">
																		<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'book']" /></span>
																	</a>
																</div>
																
															</div>
															<div class="card-body">
																<group-details :form="form
																	"></group-details>
																<div class="row">
																	<div class="col-md-6 mb-2">
																		<div class="form-group">
																			<label class="akkurate-dark d-flex justify-content-between mb-1" for="authorization_letter">
																				<div class="akkurate-dark small">
																					Authorization
																					Letter
																					<star></star>
																				</div>
																				<a class="btn btn-sm akkurate-danger-btn" @click="
																					removeFile(
																						'letter'
																					)
																					"><span class="akkurate-small text-white">
																						<font-awesome-icon :icon="[
																							'fas',
																							'trash',
																						]" /></span></a>
																			</label>
																			<b-form-group id="choose_file" label-for="choose_file">
																				<vue-dropzone ref="letterDropzone" @vdropzone-files-added="
																					onLetterFileAdded
																				" id="dropzone" :options="dropzoneOptions
																					"></vue-dropzone>
																			</b-form-group>
																			<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																			<errors v-if="
																				form
																					.errors
																					.authorization_letter
																			">
																				{{
																					form
																						.errors
																						.authorization_letter[0]
																				}}
																			</errors>
																		</div>
																	</div>
																	<div class="col-12 col-md-6 mb-2">
																		<div class="form-group">
																			<label class="akkurate-dark d-flex justify-content-between mb-1" for="group_logo">
																				<div class="akkurate-dark small">
																					Group
																					Logo<star></star>
																				</div>
																				<a class="btn btn-sm akkurate-danger-btn" @click="
																					removeFile(
																						'profile'
																					)
																					"><span class="akkurate-small text-white">
																						<font-awesome-icon :icon="[
																							'fas',
																							'trash',
																						]" /></span></a>
																			</label>
																			<b-form-group id="choose_file" label-for="choose_file">
																				<vue-dropzone ref="profileDropzone" @vdropzone-files-added="
																					onProfilePictureUpload
																				" id="dropzone" :options="dropzoneOptions
																					"></vue-dropzone>
																			</b-form-group>
																			<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																			<errors v-if="
																				form
																					.errors
																					.group_logo
																			">
																				{{
																					form
																						.errors
																						.group_logo[0]
																				}}
																			</errors>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="d-flex flex-row align-items-center justify-content-between my-2">
														<b-modal id="add-signatory-modal" size="xl" @ok="
															handleSignatorySubmit
														" header-class="akkurate-dark">
															<template #modal-title>
																<h6 class="fw-bold mb-0 akkurate-green">
																	Add
																	Signatory
																</h6>
															</template>
															<signatories :form="form" :signatory="signatory_form
																" />
															<hr />
															<div class="row">
																<div class="col-md-3">
																	<div class="form-group">
																		<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="profile_photo">
																			<div>
																				Profile
																				Photo<star></star>
																			</div>
																			<a class="btn btn-sm akkurate-danger-btn" @click="
																				removeFile
																			"><span class="akkurate-small text-white">
																					<font-awesome-icon :icon="[
																						'fas',
																						'trash',
																					]" /></span></a>
																		</label>
																		<b-form-group id="choose_file" label-for="choose_file">
																			<vue-dropzone ref="myVueDropzone" @vdropzone-files-added="
																				onSignatoryProfilePhoto
																			" id="dropzone" :options="dropzoneOptions
																				"></vue-dropzone>
																		</b-form-group>
																		<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																		<errors v-if="
																			form
																				.errors
																				.profile_photo
																		">
																			{{
																				form
																					.errors
																					.profile_photo[0]
																			}}
																		</errors>
																	</div>
																</div>
																<div class="col-md-3">
																	<div class="form-group">
																		<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="ghana_card_front">
																			<div>
																				Ghana
																				Card
																				(Front)<star></star>
																			</div>
																			<a class="btn btn-sm akkurate-danger-btn" @click="
																				removeFile
																			"><span class="akkurate-small text-white">
																					<font-awesome-icon :icon="[
																						'fas',
																						'trash',
																					]" /></span></a>
																		</label>
																		<b-form-group id="choose_file" label-for="choose_file">
																			<vue-dropzone ref="myVueDropzone" @vdropzone-files-added="
																				onSignatoryGhanaCardFront
																			" id="dropzone" :options="dropzoneOptions
																				"></vue-dropzone>
																		</b-form-group>
																		<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																		<errors v-if="
																			form
																				.errors
																				.ghana_card_front
																		">
																			{{
																				form
																					.errors
																					.ghana_card_front[0]
																			}}
																		</errors>
																	</div>
																</div>
																<div class="col-md-3">
																	<div class="form-group">
																		<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="ghana_card_back">
																			<div>
																				Ghana
																				Card
																				(Back)<star></star>
																			</div>
																			<a class="btn btn-sm akkurate-danger-btn" @click="
																				removeFile
																			"><span class="akkurate-small text-white">
																					<font-awesome-icon :icon="[
																						'fas',
																						'trash',
																					]" /></span></a>
																		</label>
																		<b-form-group id="choose_file" label-for="choose_file">
																			<vue-dropzone ref="myVueDropzone" @vdropzone-files-added="
																				onSignatoryGhanaCardBack
																			" id="dropzone" :options="dropzoneOptions
																				"></vue-dropzone>
																		</b-form-group>
																		<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																		<errors v-if="
																			form
																				.errors
																				.profile_photo
																		">
																			{{
																				form
																					.errors
																					.profile_photo[0]
																			}}
																		</errors>
																	</div>
																</div>
																<div class="col-md-3">
																	<div class="form-group">
																		<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="signature">
																			<div>
																				Signature
																				(Max.
																				2.5MB)<star></star>
																			</div>
																			<a class="btn btn-sm akkurate-danger-btn" @click="
																				removeFile
																			"><span class="akkurate-small text-white">
																					<font-awesome-icon :icon="[
																						'fas',
																						'trash',
																					]" /></span></a>
																		</label>
																		<b-form-group id="choose_file" label-for="choose_file">
																			<vue-dropzone ref="myVueDropzone" @vdropzone-files-added="
																				onSignatorySignature
																			" id="dropzone" :options="dropzoneOptions
																				"></vue-dropzone>
																		</b-form-group>
																		<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																		<errors v-if="
																			form
																				.errors
																				.signature
																		">
																			{{
																				form
																					.errors
																					.signature[0]
																			}}
																		</errors>
																	</div>
																</div>
															</div>
															<template #modal-footer="{
																ok,
																cancel,
															}">
																<b-button @click="
																	ok()
																	" v-b-modal.ok type="submit" class="akkurate-green-btn btn-size text-white">
																	<span class="akkurate-small"><font-awesome-icon :icon="[
																		'fas',
																		'plus',
																	]" />
																		Add</span></b-button>
																<b-button @click="
																	cancel()
																	" v-b-modal.cancel class="akkurate-gray-btn btn-size text-white">
																	<span class="akkurate-small"><font-awesome-icon :icon="[
																		'fas',
																		'close',
																	]" />
																		Close</span></b-button>
															</template>
														</b-modal>
													</div>

													<!-- Signatories Section -->
													<div class="card card-shape home-box mt-3">
														<div class="card-header d-flex justify-content-between align-items-center">
															<h6 class="m-0 fw-bold text-green">
																Signatories
															</h6>
															<b-button size="sm" class="btn akkurate-green-btn btn-size" v-b-modal.add-signatory-modal variant="primary">
																<span class="akkurate-small">
																	<i class="fas fa-plus"></i>
																	Add
																	Signatory</span>
															</b-button>
														</div>
														<div class="card-body">
															<vue-good-table :columns="signatory_columns
																" :rows="form.signatories
																	" />
														</div>
													</div>

													<!-- Address Section -->
													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header d-flex flex-row align-items-center">
																<h6 class="m-0 fw-bold text-green">
																	Address
																</h6>
															</div>
															<div class="card-body">
																<address-view :form="form" :region_options="region_options
																	" :branch_options="branch_options
																		"></address-view>
															</div>
														</div>
													</div>

													<!-- Accounts Section -->
													<div class="col-12 col-md-12 mt-2">
														<div class="d-flex flex-row align-items-center justify-content-between my-2">
															<AddAccount :add_account="'add-account-two'" :account_types="account_types
																" @addAccount="
																	addAccount
																">
															</AddAccount>
														</div>
														<div class="err-accounts">
															<errors v-if="
																form.errors
																	.accounts
															">{{
																form.errors
																	.accounts[0]
															}}</errors>
														</div>
														<div class="card card-shape home-box">
															<div class="card-header">
																<div class="d-flex flex-row align-items-center justify-content-between">
																	<h6 class="m-0 fw-bold text-green">
																		Accounts
																	</h6>
																	<b-button size="sm" class="fw-semibold akkurate-green-btn btn-size" @click="
																		$bvModal.show(
																			'add-account-two'
																		)
																		">
																		<span class="akkurate-small">
																			<i class="fas fa-plus"></i>
																			Add
																			Acounts
																		</span>
																	</b-button>
																</div>
															</div>
															<div class="card-body">
																<vue-good-table :columns="columns
																	" :rows="form.accounts
																		" />
															</div>
														</div>
													</div>


													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header">
																<div class="d-flex flex-row align-items-center justify-content-between">
																	<h6 class="m-0 fw-bold text-green">
																		Account Priority Type
																	</h6>
																</div>
															</div>
															<div class="card-body">
																<!-- <vue-good-table :columns="columns" :rows="form.accounts
															" /> -->

																<div class="row">
																	<div class="col-12 col-md-6 mb-2">
																		<label class="akkurate-dark small" for="priority">Priority Type<star></star></label>
																		<b-form-group id="priority" label-for="priority">
																			<multiselect class="mt-1 field-container" v-model="selectedPriority" :options="priorityTypeOptions" label="name" >
																			</multiselect>
																			<errors v-if="form.errors.customer_category">
																				{{ form.errors.customer_category[0] }}
																			</errors>
																		</b-form-group>
																	</div>

																	<div class="col-12 col-md-6 mb-2">
																		<b-form-group label-for="priority_note" class="mb-2">
																			<template #label>
																				<label class="akkurate-dark small" for="priority_note">Note </label>
																			</template>
																			<b-form-input class="mt-1 field-container fields" type="text" placeholder="" v-model="setNote" disabled></b-form-input>
																			<!-- <b-form-textarea class="mt-1 fields" id="priority_note" v-model="setNote" placeholder=""></b-form-textarea> -->
																		</b-form-group>

																	</div>
																</div>
															</div>
														</div>
													</div>

												</div>
											</div>
										</b-tab>
										<!-- Corporate Tab -->
										<b-tab title="CORPORATE" @click="
											setCustomerType('CORPORATE')
											">
											<div class="row">
												<div class="col-12">
													<!-- Corporate Information -->
													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header d-flex flex-row justify-content-between align-items-center">
																<h6 class="m-0 fw-bold text-green">
																	Corporate
																	Information
																</h6>

																<div class="d-flex gap-2">
																	<a title="Print Form" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="showPrintableFormModal('corporate_filled')">
																		<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'print']" /></span>
																	</a>
																	<a title="Get Empty Form" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="showPrintableFormModal('corporate')">
																		<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'book']" /></span>
																	</a>
																</div>
															</div>
															<div class="card-body">
																<div class="row">
																	<corporate-details :form="form
																		"></corporate-details>
																	<!-- Your existing corporate fields -->
																</div>

																<!-- Documents Section -->
																<div class="row mt-2">
																	<div class="col-12 col-md-4 mb-2">
																		<div class="form-group">
																			<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="recorded_date">
																				<div>
																					Incorporation
																					Certificate<star></star>
																				</div>
																				<a class="btn btn-sm akkurate-danger-btn" @click="
																					removeFile(
																						'incorporationCertificate'
																					)
																					"><span class="akkurate-small text-white">
																						<font-awesome-icon :icon="[
																							'fas',
																							'trash',
																						]" /></span></a>
																			</label>
																			<b-form-group id="choose_file" label-for="choose_file">
																				<vue-dropzone ref="inncoporateDropzone" @vdropzone-files-added="
																					onIncorporateFileAdded
																				" id="dropzone" :options="dropzoneOptions
																					"></vue-dropzone>
																			</b-form-group>
																			<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																			<errors v-if="
																				form
																					.errors
																					.incorporation_certificate
																			">
																				{{
																					form
																						.errors
																						.incorporation_certificate[0]
																				}}
																			</errors>
																		</div>
																	</div>
																	<div class="col-12 col-md-4">
																		<div class="form-group">
																			<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="recorded_date">
																				<div>
																					Commencement
																					Certificate<star></star>
																				</div>
																				<a class="btn btn-sm akkurate-danger-btn" @click="
																					removeFile(
																						'commerncementCertificate'
																					)
																					"><span class="akkurate-small text-white">
																						<font-awesome-icon :icon="[
																							'fas',
																							'trash',
																						]" /></span></a>
																			</label>
																			<b-form-group id="choose_file" label-for="choose_file">
																				<vue-dropzone ref="commencementDropzone" @vdropzone-files-added="
																					onCommercialFileAdded
																				" id="dropzone" :options="dropzoneOptions
																					"></vue-dropzone>
																			</b-form-group>
																			<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																			<errors v-if="
																				form
																					.errors
																					.commencement_certificate
																			">
																				{{
																					form
																						.errors
																						.commencement_certificate[0]
																				}}
																			</errors>
																		</div>
																	</div>
																	<div class="col-12 col-md-4">
																		<div class="form-group">
																			<label class="akkurate-dark d-flex justify-content-between mb-1 small" for="recorded_date">
																				<div>
																					Corporate
																					Logo<star></star>
																				</div>
																				<a class="btn btn-sm akkurate-danger-btn" @click="
																					removeFile(
																						'profile'
																					)
																					"><span class="akkurate-small text-white">
																						<font-awesome-icon :icon="[
																							'fas',
																							'trash',
																						]" /></span></a>
																			</label>
																			<b-form-group id="choose_file" label-for="choose_file">
																				<vue-dropzone ref="profileDropzone" @vdropzone-files-added="
																					onProfilePictureUpload
																				" id="dropzone" :options="dropzoneOptions
																					"></vue-dropzone>
																			</b-form-group>
																			<!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
																			<errors v-if="
																				form
																					.errors
																					.group_logo
																			">
																				{{
																					form
																						.errors
																						.group_logo[0]
																				}}
																			</errors>
																		</div>
																	</div>

																	<!-- <div class="col-md-6">
                                    <div class="form-group">
                                      <label>Commencement Certificate</label>
                                      <b-form-group id="commercial_certificate" label-for="commercial_certificate"
                                        class="akkurate-dark">
                                        <b-form-input @change="handleCommercialCertificate" id="commercial_certificate"
                                          class="mb-3 mt-2 field-container fields" type="file">
                                        </b-form-input>
                                      </b-form-group>
                                      <errors v-if="form.errors.commencement_certificate">{{
                                        form.errors.commencement_certificate[0] }}</errors>
                                    </div>
                                  </div> -->
																</div>
															</div>
														</div>
													</div>

													<!-- Address Section -->
													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header d-flex flex-row align-items-center">
																<h6 class="m-0 fw-bold text-green">
																	Address
																</h6>
															</div>
															<div class="card-body">
																<address-view :form="form" :region_options="region_options
																	" :branch_options="branch_options
																		"></address-view>
															</div>
														</div>
													</div>

													<!-- Accounts Section -->
													<div class="col-12 col-md-12 mt-2">
														<div class="d-flex flex-row align-items-center justify-content-between my-2">
															<AddAccount :add_account="'add-account-three'" :account_types="account_types
																" @addAccount="
																	addAccount
																">
															</AddAccount>
														</div>
														<div class="err-accounts">
															<errors v-if="
																form.errors
																	.accounts
															">{{
																form.errors
																	.accounts[0]
															}}</errors>
														</div>
														<div class="card card-shape home-box">
															<div class="card-header">
																<div class="d-flex flex-row align-items-center justify-content-between">
																	<h6 class="m-0 fw-bold text-green">
																		Accounts
																	</h6>
																	<b-button size="sm" class="fw-semibold akkurate-green-btn" @click="
																		$bvModal.show(
																			'add-account-three'
																		)
																		">
																		<span class="akkurate-small">
																			<i class="fas fa-plus"></i>
																			Add
																			Acounts
																		</span>
																	</b-button>
																</div>
															</div>
															<div class="card-body">
																<vue-good-table :columns="columns
																	" :rows="form.accounts
																		" />
															</div>
														</div>
													</div>


													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header">
																<div class="d-flex flex-row align-items-center justify-content-between">
																	<h6 class="m-0 fw-bold text-green">
																		Account Priority Type
																	</h6>
																</div>
															</div>
															<div class="card-body">
																<!-- <vue-good-table :columns="columns" :rows="form.accounts
															" /> -->

																<div class="row">
																	<div class="col-12 col-md-6 mb-2">
																		<label class="akkurate-dark small" for="priority">Priority Type<star></star></label>
																		<b-form-group id="priority" label-for="priority">
																			<multiselect class="mt-1 field-container" v-model="selectedPriority" :options="priorityTypeOptions" label="name">
																			</multiselect>
																			<errors v-if="form.errors.customer_category">
																				{{ form.errors.customer_category[0] }}
																			</errors>
																		</b-form-group>
																	</div>

																	<div class="col-12 col-md-6 mb-2">
																		<b-form-group label-for="priority_note" class="mb-2">
																			<template #label>
																				<label class="akkurate-dark small" for="priority_note">Note </label>
																			</template>
																			<b-form-input class="mt-1 field-container fields" type="text" placeholder="" v-model="setNote" disabled></b-form-input>
																			<!-- <b-form-textarea class="mt-1 fields" id="priority_note" v-model="setNote" placeholder=""></b-form-textarea> -->
																		</b-form-group>

																	</div>
																</div>
															</div>
														</div>
													</div>

													<!-- Signatories Section -->
													<div class="col-12 col-md-12 mt-2">
														<div class="card card-shape home-box">
															<div class="card-header">
																<div class="d-flex flex-row align-items-center justify-content-between">
																	<h6 class="m-0 fw-bold text-green">
																		Signatories
																	</h6>
																	<b-button class="btn btn-sm akkurate-green-btn" v-b-modal.add-signatory-modal variant="primary">
																		<span class="akkurate-small">
																			<i class="fas fa-plus"></i>
																			Add
																			Signatory</span>
																	</b-button>
																</div>
															</div>
															<div class="card-body">
																<div class="d-flex justify-content-end mb-3">
																	<!-- <b-button @click="addSignatory" variant="success" size="sm">
                                    Add Signatory
                                  </b-button> -->
																</div>
																<vue-good-table :columns="signatory_columns
																	" :rows="form.signatories
																		" />
															</div>
														</div>
													</div>
												</div>
											</div>
										</b-tab>
									</b-tabs>
								</b-card>
								<div class="mt-2">
									<SaveButton :isSaving="isSaving" />
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
			<Footer></Footer>
		</div>
		<!-- Printable Forms Modals -->
		<!-- Empty Printable Forms Modals -->
		<printable-member-form-individual/>
		<printable-member-form-group/>
		<printable-member-form-corporate/>
		<!-- Filled Printable Forms Modals -->
		<printable-member-form-individual-filled :form="this.form" :files="this.files"/>
		<printable-member-form-group-filled :form="this.form" :files="this.files"/>
		<printable-member-form-corporate-filled :form="this.form" :files="this.files"/>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import Footer from "@/views/main/components/Footer.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import AddressView from "../forms/Address";
import PersonalDetails from "../forms/PersonalDetails";
import SpouseDetails from "../forms/SpouseDetails";
import EmployerDetails from "../forms/EmployerDetails";
import EmergencyContactDetails from "../forms/EmergencyContactDetails";
import FinancialInformation from "../forms/FinancialInformation";
import AddAccount from "../forms/Modal/AddAccount";
import NextOfKin from "../forms/Modal/NextOfKin.vue";
import ApiService from "@/core/services/api.service";
import SaveButton from "@/views/main/components/SaveButton.vue";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Multiselect from "vue-multiselect";
import GroupDetails from "../forms/GroupDetails.vue";
import CorporateDetails from "../forms/CorporateDetails.vue";
import Signatories from "../forms/Modal/Signatories.vue";
// Empty Printable Forms
import PrintableMemberFormIndividual from "../forms/Application_Forms_Empty/PrintableMemberFormIndividual.vue";
import PrintableMemberFormGroup from "../forms/Application_Forms_Empty/PrintableMemberFormGroup.vue";
import PrintableMemberFormCorporate from "../forms/Application_Forms_Empty/PrintableMemberFormCorporate.vue";
// Filled Printable Forms
import PrintableMemberFormIndividualFilled from "../forms/Application_Forms_Filled/PrintableMemberFormIndividualFilled.vue";
import PrintableMemberFormGroupFilled from "../forms/Application_Forms_Filled/PrintableMemberFormGroupFilled.vue";
import PrintableMemberFormCorporateFilled from "../forms/Application_Forms_Filled/PrintableMemberFormCorporateFilled.vue";

export default {
	name: "CreateMember",
	mounted() {
		this.loadPageOptions();
	},
	components: {
		SidebarView,
		Footer,
		TopbarView,
		AddressView,
		PersonalDetails,
		AddAccount,
		NextOfKin,
		EmployerDetails,
		FinancialInformation,
		SpouseDetails,
		EmergencyContactDetails,
		SaveButton,
		vueDropzone,
		Multiselect,
		GroupDetails,
		CorporateDetails,
		Signatories,
		PrintableMemberFormIndividual,
		PrintableMemberFormGroup,
		PrintableMemberFormCorporate,
		PrintableMemberFormIndividualFilled,
		PrintableMemberFormGroupFilled,
		PrintableMemberFormCorporateFilled,
	},
	data() {
		return {
			...this.initiateState(),
			front_card_path: "",
			front_card_name: "",
			back_card_path: "",
			back_card_name: "",
			region_options: [],
			branch_options: [],
			selectedPriority: {},
			isSaving: false,
			dropzoneOptions: {
				url: "https://httpbin.org/post",
				thumbnailWidth: 100,
				maxFilesize: 0.5,
				headers: { "My-Awesome-Header": "header value" },
			},
			priorityTypeOptions: [
				{ name: "Standard", value: "standard" },
				{ name: "Premium", value: "premium" },
				{ name: "Executive", value: "executive" }
			],
			// uploads: {
			//   front_ghana_card: null,
			//   back_ghana_card: null,
			//   signature: null,
			// },

			// regions: [],
			// branches: [],
			files: {
				letter_file: null,
				incorporate_file: null,
				commercial_file: null,
				profile_file: null,
				ghana_card_front_file: null,
				ghana_card_back_file: null,
				signature_file: null,
				signatory_profile_file: null,
				signatory_ghana_front_file: null,
				signatory_ghana_back_file: null,
				signatory_signature_file: null,

			},
			account_types: [],
			add_or_edit: "add",
			// Add inside data() return object
			activeTab: 0,
			group_form: {
				fund_source: "",
				authorization_letter: "",
				signatories: [],
			},
			corporate_form: {
				fund_source: "",
				incorporation_certificate: "",
				commencement_certificate: "",
				company_regulations: "",
				company_physical_address_type: "",
				company_physical_address_file: "",
				annual_returns: "",
				board_resolution: "",
				business_registration_act_form_a: "",
				tin_number: "",
				business_type: "",
				signatories: [],
			},
			incorporate_file: "",
			commercial_file: "",
			letter_file: "",
			signatory_form: {
				name: "",
				position: "",
				id_type: null,
				id_number: "",
				signatory_type: "",
				profile_photo: null,
				ghana_card_front: null,
				ghana_card_back: null,
				signature: null,
				errors: {},
			},
			signatory_profile_file: null,
			signatory_ghana_front_file: null,
			signatory_ghana_back_file: null,
			signatory_signature_file: null,
			signatory_columns: [
				{
					label: "Name",
					field: "name",
				},
				{
					label: "Position",
					field: "position",
				},
				{
					label: "ID Type",
					field: "id_type",
				},
				{
					label: "Signatory Type",
					field: "signatory_type",
				},
				{
					label: "ID Number",
					field: "id_number",
				},
			],
			columns: [
				{
					label: "Account Type",
					field: "account_type.name",
				},
				{
					label: "Balance",
					field: "account_balance",
				},
				{
					label: "Status",
					field: "status",
				},
			],
			kin_columns: [
				{
					label: "Surname",
					field: "surname",
				},
				{
					label: "Other name(s)",
					field: "other_names",
				},
				{
					label: "Email",
					field: "email",
				},
				{
					label: "Date of birth",
					field: "dob",
				},
				{
					label: "Phone Number",
					field: "phone",
				},
				{
					label: "Percentage Shares",
					field: "percentage_share",
				},
				{
					label: "Relation",
					field: "relation",
				},
				{
					label: "Address",
					field: "address",
				},
			],
			kin_rows: [],
		};
	},
	watch: {
		'selectedPriority'(val) {
			this.form.customer_category = val.value;
		}
	},
	computed: {
		// Add to computed properties
		setNote() {
			if (this.selectedPriority?.value === "standard") {
				return "Accessible by every user role.";
			} else if (this.selectedPriority?.value === "premium") {
				return "Not Accessible by Mobile Bankers, Tellers and FrontDesk.";
			} else if (this.selectedPriority?.value === "executive") {
				return "Accessible to only General Manager, Accountant and Board Chairman.";
			}
			return "";
		},

		// setPriority() {
		// 	this.form.customer_category = this.selectedPriority ? this.selectedPriority?.value : "";
		// 	return this.selectedPriority
		// }
	},

	methods: {
		// Add to methods object
		onCategoryChange(value) {
			this.form.customer_category = value.value;

			console.log('Hello world', this.form.customer_category)
		},

		showPrintableFormModal(type) {
			// this.member_id = id;
			// this.institution = institution
			// this.selectedCustomerNumber = mobileNumber;
			// console.log("SELECTED:", this.selectedCustomerNumber); // ✅ should show the right value

			this.$nextTick(() => {
				this.$bvModal.show("printable_form_"+type);
			});
		},
		setCustomerType(type) {
			this.form.customer_type = type;
			if (type === "GROUP") {
				this.form = {
					...this.initiateState().form,
					...this.group_form,
					customer_type: type,
				};
			} else if (type === "CORPORATE") {
				this.form = {
					...this.initiateState().form,
					...this.corporate_form,
					customer_type: type,
				};
			} else {
				this.form = {
					...this.initiateState().form,
					customer_type: type,
				};
			}
		},

		// Modify your existing submitMember method
		submitMember() {
			// console.log("Here");
			this.form.message = "";
			this.form.errors = [];

			// // Add type-specific validations
			// if (this.form.customer_type === 'GROUP') {
			//   if (!this.form.fund_source) {
			//     this.form.errors.fund_source = ['Fund source is required'];
			//     return;
			//   }
			//   if (!this.form.authorization_letter) {
			//     this.form.errors.authorization_letter = ['Authorization letter is required'];
			//     return;
			//   }
			//   if (!this.form.signatories.length) {
			//     this.form.errors.signatories = ['At least one signatory is required'];
			//     return;
			//   }
			// } else if (this.form.customer_type === 'CORPORATE') {
			//   if (!this.form.business_type) {
			//     this.form.errors.business_type = ['Business type is required'];
			//     return;
			//   }
			//   if (!this.form.tin_number) {
			//     this.form.errors.tin_number = ['TIN number is required'];
			//     return;
			//   }
			//   // Add other corporate validations
			// }

			// Your existing submit logic continues here...
			// this.form.gh_card_front_path = this.front_card_path;
			// this.form.gh_card_front_name = this.front_card_name;
			// this.form.gh_card_back_path = this.back_card_path;
			// this.form.gh_card_back_name = this.back_card_name;

			this.isSaving = true;
			this.$Progress.start();

			console.log(this.form);

			this.uploadImage().then(() => {
				ApiService.post("/customers/store", this.form)
					.then((response) => {
						this.isSaving = false;
						this.$Progress.finish();
						toast.fire({
							icon: "success",
							title: response.data.message,
						});
						this.form = this.initiateState().form;
						setTimeout(() => {
							window.location.reload();
						}, 1000);
					})
					.catch((error) => {
						this.isSaving = false;
						this.$Progress.fail();
						if (error.response.data.errors) {
							this.form.errors = error.response.data.errors;
						}
						if (error.response.data.message) {
							this.form.message = error.response.data.message;
						}
					});
			});
		},

		uploadImage() {
			const uploads = [];
			if (this.letter_file) {
				this.upload = "Processing...";
				const data = new FormData();
				data.append("file", this.letter_file);
				data.append("is_document", "1");
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.form.authorization_letter =
								response.data.path;
						}
					)
				);
			}

			// Handle incorporation certificate upload
			if (this.incorporate_file) {
				this.upload = "Processing...";
				const incData = new FormData();
				incData.append("file", this.incorporate_file);
				incData.append("is_document", "1");
				uploads.push(
					ApiService.post("/images/store", incData).then(
						(response) => {
							this.form.incorporation_certificate =
								response.data.path;
						}
					)
				);
			}

			// Handle commercial certificate upload
			if (this.commercial_file) {
				this.upload = "Processing...";
				const commData = new FormData();
				commData.append("file", this.commercial_file);
				commData.append("is_document", "1");
				uploads.push(
					ApiService.post("/images/store", commData).then(
						(response) => {
							this.form.commencement_certificate =
								response.data.path;
						}
					)
				);
			}
			if (this.profile_file) {
				this.upload = "Processing...";
				const data = new FormData();
				data.append("file", this.profile_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.form.passport_pic_path =
								response.data.path;
							this.form.passport_pic_name =
								response.data.name;
						}
					)
				);
			}
			if (this.ghana_card_front_file) {
				this.upload = "Processing...";
				const data = new FormData();
				data.append("file", this.ghana_card_front_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.form.gh_card_front_path =
								response.data.path;
							this.form.gh_card_front_name =
								response.data.name;
						}
					)
				);
			}
			if (this.ghana_card_back_file) {
				this.upload = "Processing...";
				const data = new FormData();
				data.append("file", this.ghana_card_back_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.form.gh_card_back_path =
								response.data.path;
							this.form.gh_card_back_name =
								response.data.name;
						}
					)
				);
			}
			if (this.signature_file) {
				this.upload = "Processing...";
				const data = new FormData();
				data.append("file", this.signature_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.form.signature_image_path =
								response.data.path;
							this.form.signature_image_name =
								response.data.name;
						}
					)
				);
			}

			// Return Promise.all to wait for all uploads to complete
			return uploads.length
				? Promise.all(uploads)
					.then(() => {
						this.upload = "Uploaded";
					})
					.catch((error) => {
						this.upload = "Failed";
						throw new Error(
							"File upload failed: " + error.message
						);
					})
				: Promise.resolve();
		},

		onLetterFileAdded(event) {
			this.files.letter_file = event[0]
			this.letter_file = event[0];
		},
		onIncorporateFileAdded(event) {
			this.files.incorporate_file = event[0];
			this.incorporate_file = event[0];
		},
		onCommercialFileAdded(event) {
			this.files.commercial_file = event[0];
			this.commercial_file = event[0];
		},
		onProfilePictureUpload(event) {
			this.files.profile_file = event[0];
			this.profile_file = event[0];
		},
		onGhanaCardFrontUpload(event) {
			this.files.ghana_card_front_file = event[0];
			this.ghana_card_front_file = event[0];
		},
		onGhanaCardBackUpload(event) {
			this.files.ghana_card_back_file = event[0];
			this.ghana_card_back_file = event[0];
		},
		onSignatureUpload(event) {
			this.files.signature_file = event[0];
			this.signature_file = event[0];
		},
		onSignatoryProfilePhoto(event) {
			this.files.signatory_profile_file = event[0];
			this.signatory_profile_file = event[0];
		},

		onSignatoryGhanaCardFront(event) {
			this.files.signatory_ghana_front_file = event[0];
			this.signatory_ghana_front_file = event[0];
		},

		onSignatoryGhanaCardBack(event) {
			this.files.signatory_ghana_back_file = event[0];
			this.signatory_ghana_back_file = event[0];
		},

		onSignatorySignature(event) {
			this.files.signatory_signature_file = event[0];
			this.signatory_signature_file = event[0];
		},
		async uploadSignatoryFiles() {
			const uploads = [];

			if (this.signatory_profile_file) {
				const data = new FormData();
				data.append("file", this.signatory_profile_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.signatory_form.profile_photo =
								response.data.path;
						}
					)
				);
			}

			if (this.signatory_ghana_front_file) {
				const data = new FormData();
				data.append("file", this.signatory_ghana_front_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.signatory_form.ghana_card_front =
								response.data.path;
						}
					)
				);
			}

			if (this.signatory_ghana_back_file) {
				const data = new FormData();
				data.append("file", this.signatory_ghana_back_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.signatory_form.ghana_card_back =
								response.data.path;
						}
					)
				);
			}

			if (this.signatory_signature_file) {
				const data = new FormData();
				data.append("file", this.signatory_signature_file);
				uploads.push(
					ApiService.post("/images/store", data).then(
						(response) => {
							this.signatory_form.signature =
								response.data.path;
						}
					)
				);
			}

			return Promise.all(uploads);
		},
		async handleSignatorySubmit() {
			try {
				// Upload files first
				await this.uploadSignatoryFiles();

				// Validate form
				if (
					!this.signatory_form.name ||
					!this.signatory_form.position ||
					!this.signatory_form.id_type ||
					!this.signatory_form.id_number
				) {
					this.signatory_form.errors = {
						message: "Please fill all required fields",
					};
					return;
				}

				// Add signatory to the list
				this.form.signatories.push({
					name: this.signatory_form.name,
					position: this.signatory_form.position,
					id_type: this.signatory_form.id_type,
					id_number: this.signatory_form.id_number,
					signatory_type: this.signatory_form.signatory_type,
					profile_photo: this.signatory_form.profile_photo,
					ghana_card_front: this.signatory_form.ghana_card_front,
					ghana_card_back: this.signatory_form.ghana_card_back,
					signature: this.signatory_form.signature,
				});

				// Reset form and files
				this.signatory_form = {
					name: "",
					position: "",
					id_type: null,
					id_number: "",
					signatory_type: "",
					profile_photo: null,
					ghana_card_front: null,
					ghana_card_back: null,
					signature: null,
					errors: {},
				};

				this.signatory_profile_file = null;
				this.signatory_ghana_front_file = null;
				this.signatory_ghana_back_file = null;
				this.signatory_signature_file = null;

				// Clear dropzones
				this.$refs.myVueDropzone.removeAllFiles();

				// Close modal
				this.$bvModal.hide("add-signatory-modal");

				// Show success message
				this.$bvToast.toast("Signatory added successfully", {
					title: "Success",
					variant: "success",
					solid: true,
				});
			} catch (error) {
				console.error("Error adding signatory:", error);
				this.signatory_form.errors = {
					message: "Error adding signatory. Please try again.",
				};
			}
		},

		loadPageOptions() {
			this.$Progress.start();
			this.isLoading = true;
			ApiService.get("/customers/dropdown")
				.then((response) => {
					console.log(response.data);
					this.account_types = response.data.account_types;
					this.region_options = response.data.regions;
					this.branch_options = response.data.branches;
					this.users_option = response.data.users;
					this.isLoading = false;
					// $emit('coa-head-saved', response.data)
					this.$Progress.finish();
				})
				.catch((error) => {
					this.isLoading = false;
					this.$Progress.fail();
				});
		},
		addAccount(acc) {
			var account = {};
			account.account_type = acc.account_type;
			account.account_balance = acc.account_balance;
			account.status = acc.status;
			this.form.accounts.push(account);
			this.$bvModal.hide("add-account-one");
			this.$bvModal.hide("add-account-two");
			this.$bvModal.hide("add-account-three");

			// { acc_id: 1, account_type: "John", acc_num:"11111111", account_balance: 20, created_at: '2011-10-31' }
		},
		addBeneficiary(nok) {
			let totalPercentage = 0;


			
			var nextofkin = {};
			nextofkin.surname = nok.surname;
			nextofkin.other_names = nok.other_names;
			nextofkin.email = nok.email;
			nextofkin.dob = nok.dob;
			nextofkin.phone = nok.phone;
			nextofkin.relation = nok.relation;
			nextofkin.address = nok.address;
			nextofkin.percentage_share = nok.percentage_share;

			this.form.beneficiaries?.forEach(beneficiary => {
				totalPercentage += Number(beneficiary.percentage_share)
			});

			totalPercentage += Number(nextofkin.percentage_share);
			
			if (totalPercentage > 100) {
				swal.fire({
					title: "Percentage Share Error",
					text: `Beneficiary ${nextofkin.other_names} ${nextofkin.surname} could not be added because Total Percentage Share exceeds 100%`,
					icon: "error",
					allowOutsideClick: true,
					allowEscapeKey: true,
					showCancelButton: false, // Show the "Cancel" button
					confirmButtonText: "okay", // Customize the text for the "OK" button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					},
				});

				return;
			}

			this.form.beneficiaries.push(nextofkin);
		},

		initiateState() {
			return {
				users_option: [],
				form: {
					accounts: [],
					beneficiaries: [],
					first_name: "",
					middlename: "",
					last_name: "",
					title: "",
					email: "",
					mobile: "",
					customer_category: "",
					mobile_secondary: "",
					unapproved_withdrawal_max_amount: "",
					gender: "",
					date_of_birth: "",
					marital_status: "",
					address: "",
					digital_address: "", //not required
					home_town: "", //not required
					landmark: "",
					region: "",
					branch: "",
					external_code: "",
					staff_id: "",
					employer_name: null, //not required
					ghana_card_number: null, //not required
					status: "Pending",
					customer_type: "INDIVIDUAL",
					// region_options: [],
					// branch_options: [],
					errors: [],
					message: "",
					gh_card_front_path: "",
					gh_card_front_name: "",
					gh_card_back_name: "",
					gh_card_back_path: "",

					employer_address: null,
					employer_mobile: null,
					occupation: null,
					employee_position: null,
					source_of_funds: null,
					bankers_name: null,
					bankers_address: null,
					bankers_location: null,
					monthly_salary: null,
					signature_image_path: null,
					signature_image_name: null,
					passport_pic_path: null,
					passport_pic_name: null,
					note: null,
					mandate: null,
					bank_account_number: null,
					nearest_landmark: null,
					spouse_name: null,
					spouse_phone: null,
					spouse_email: null,
					spouse_address: null,
					mobile_secondary: null,
					latitude: null,
					longitude: null,
					employment_status: "",
					reference_name: null,
					reference_phone: null,
					reference_email: null,
					reference_address: null,
					fund_source: "",
					authorization_letter: "",
					signatories: [],
					incorporation_certificate: "",
					commencement_certificate: "",
					company_regulations: "",
					company_physical_address_type: "",
					company_physical_address_file: "",
					annual_returns: "",
					board_resolution: "",
					business_registration_act_form_a: "",
					tin_number: "",
					business_type: "",
					ro: "",
					place_of_work: "",

				},
			};
		},

		removeFile(dropzoneType) {
			let dropzone;
			switch (dropzoneType) {
				case "profile":
					dropzone = this.$refs.profileDropzone;
					break;
				case "ghanaCardFront":
					dropzone = this.$refs.ghanaCardFrontDropzone;
					break;
				case "ghanaCardBack":
					dropzone = this.$refs.ghanaCardBackDropzone;
					break;
				case "signature":
					dropzone = this.$refs.signatureDropzone;
					break;
				case "incorporationCertificate":
					dropzone = this.$refs.inncoporateDropzone;
					break;
				case "commerncementCertificate":
					dropzone = this.$refs.commencementDropzone;
					break;
			}

			if (dropzone && dropzone.dropzone.files.length > 0) {
				// Remove all files
				dropzone.dropzone.removeAllFiles();
			}
		},
	},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
